import React, { createContext, useState, useEffect } from 'react';

export const SalesRootContext = createContext();

export const SalesRootProvider = ({ children }) => {
    const [salesRootData, setSalesRootData] = useState({
        company: '',
        TLAP_id: '',
        TLAP_name: '',
        sales_root: [],
        group: '',
        selectedRoot: '',
        tempReserveInfo: {},
    });

    useEffect(() => {
        // console.log('Sales root data changed:', salesRootData);
    }, [salesRootData]);

    return (
        <SalesRootContext.Provider value={{ salesRootData, setSalesRootData }}>
            {children}
        </SalesRootContext.Provider>
    );
};
